import React, { useState, useEffect } from "react";
import "./MerchantOverview.css";
import { useSelector } from "react-redux";
import ReactSelect from "react-select";
import Select from "react-select";
import { getAllUsers, fetchAllProviders } from "../../../config/LiveApi";
import DateFilter from "../../../components/common/DateFilter";

const DashboardHeader = ({
  onOrgNameChange,
  onMerchNameChange,
  onProviderChange,
  onDateChange,
  merchName,
}) => {
  const [merchantNames, setMerchantNames] = useState([]);
  const [providersLoading, setProvidersLoading] = useState(true);
  const [providersName, setProvidersName] = useState([]);
  const [selectedMerchant, setSelectedMerchant] = useState(null);
  const [selectedProvider, setSelectedProvider] = useState({
    label: "All",
    value: "All",
    providerName: "All",
    orgName: "All",
  });
  const [providersByType, setProvidersByType] = useState({
    payin: [],
    payout: [],
    both: [],
  });

  const token = useSelector((store) => store.userReducer.token);

  useEffect(() => {
    const fetchMerchNames = async () => {
      try {
        const response = await getAllUsers(token, 1);
        const filteredData = await response.data.filter((merchant) => {
          return merchant.role === "admin";
        });
        setMerchantNames(filteredData);
        setSelectedMerchant(null);
      } catch (error) {
        console.error("Error fetching merchants:", error);
      }
    };

    fetchMerchNames();
  }, [token]);

  useEffect(() => {
    const fetchMerchDetails = async () => {
      if (selectedMerchant.name) {
        try {
          setProvidersLoading(true);

          const response = await fetchAllProviders(token);
          const providerName = response.data.providers;
          const allProvider = {
            type: "All",
            providerName: "All",
            orgName: "All",
          };

          const modifiedProviderList = [allProvider, ...providerName];
          setProvidersName(modifiedProviderList);

          const defaultAll = {
            label: "All",
            value: "All : All - All",
            providerName: "All",
            orgName: "All",
          };
          setSelectedProvider(defaultAll);
          onOrgNameChange("All");
        } catch (error) {
          console.error("Error fetching provider details:", error);
          setProvidersLoading(false);
        }
      }
    };

    fetchMerchDetails();
  }, [selectedMerchant]);

  useEffect(() => {
    if (selectedMerchant) {
      onMerchNameChange(selectedMerchant.value);
      setSelectedProvider({
        label: "All",
        value: "All : All - All",
        providerName: "All",
        orgName: "All",
      });

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const end = new Date();
      end.setHours(23, 59, 59, 999);

      onDateChange(today.toISOString(), end.toISOString());
    }
  }, [selectedMerchant]);

  const MerchantOptions = merchantNames.map((merch) => ({
    value: merch?.id,
    label: merch?.alias ? merch?.alias : merch?.id,
  }));

  const handleMerchChange = (selectedOption) => {
    if (!selectedOption) {
      setSelectedMerchant(null);
      onMerchNameChange("");
      return;
    }
    setSelectedMerchant({
      name: selectedOption.label,
      value: selectedOption.value,
    });
    setSelectedProvider({
      label: "All",
      value: "All ",
      providerName: "All",
      orgName: "All",
    });
  };

  const handleSelectChangePayout = (selectedOption) => {
    if (selectedOption) {
      setSelectedProvider(selectedOption);
      onProviderChange(selectedOption);
      onOrgNameChange(selectedOption.orgName);
    }
  };

  const providerOptions = providersName.map((p) => ({
    label:
      p.providerName === "All"
        ? "All"
        : `${p.type} : ${p.providerName} - ${p.orgName}`,
    value: `${p.type} : ${p.providerName} - ${p.orgName}`,
    providerName: p.providerName,
    orgName: p.orgName,
  }));

  const groupedOptions = [
    {
      label: "All",
      options: providerOptions.filter(
        (opt) => opt.label.split(" : ")[0] === "All",
      ),
    },
    {
      label: "Payin",
      options: providerOptions.filter(
        (opt) => opt.label.split(" : ")[0] === "payin",
      ),
    },
    {
      label: "Payout",
      options: providerOptions.filter(
        (opt) => opt.label.split(" : ")[0] === "payout",
      ),
    },
    {
      label: "Both",
      options: providerOptions.filter(
        (opt) => opt.label.split(" : ")[0] === "both",
      ),
    },
  ];

  const handleDateChange = (start, end) => {
    onDateChange(start, end);
  };

  return (
    <div className="header-box-cal">
      <div className="dash-head">
        <p className="dash-p">Dashboard</p>
        <ReactSelect
          value={
            selectedMerchant
              ? {
                  value: selectedMerchant.value,
                  label: selectedMerchant.name,
                }
              : null
          }
          options={MerchantOptions}
          onChange={handleMerchChange}
          placeholder="Select Merchant"
          isClearable
        />
      </div>

      <div className="dash-sub-head">
        <p className="overview">
          Overview of{" "}
          <span className="selectedOrg">
            {selectedMerchant?.name || "Select Merchant"}
          </span>
        </p>
      </div>
      <DateFilter onDateChange={handleDateChange} />

      <div className="provider-dropdown">
        <p className="overview">Providers :</p>
        <Select
          className="provider-select"
          value={providerOptions.find(
            (opt) => opt.value === selectedProvider.value,
          )}
          onChange={handleSelectChangePayout}
          options={groupedOptions}
        />
      </div>
    </div>
  );
};

export default DashboardHeader;
